import PropTypes from 'prop-types';
import React from 'react';
import bindAll from 'lodash.bindall';

import {connect} from 'react-redux';
import {compose} from 'redux';
import {injectIntl, intlShape} from 'react-intl';

import {closeUploadProgress} from '../reducers/modals';
import {resetFlashProgress} from '../reducers/flash-progress';
import {resetInitProgress} from '../reducers/init-progress';
import {resetEsp32Upload} from '../reducers/esp32-upload';

import Esp32UploadProgressComponent from '../components/esp32-upload-progress/esp32-upload-progress.jsx';

class Esp32UploadProgress extends React.Component {
    constructor(props) {
        super(props);
        bindAll(this, [
            'handleAbort',
            'handleClose'
        ]);
    }

    handleAbort() {
        this.props.onCloseUploadProgress();
        this.props.onResetFlashProgress();
        this.props.onResetInitProgress();
        this.props.onResetEsp32Upload();
    }

    handleClose() {
        this.props.onCloseUploadProgress();
        this.props.onResetFlashProgress();
        this.props.onResetInitProgress();
        this.props.onResetEsp32Upload();
    }

    render() {
        // Chỉ hiển thị modal khi deviceId là arduinoEsp32S3
        if (this.props.deviceId !== 'arduinoEsp32S3') {
            return null;
        }

        return (
            <Esp32UploadProgressComponent
                text={this.props.esp32Upload.text}
                phase={this.props.esp32Upload.phase}
                abortEnabled={this.props.esp32Upload.abortEnabled}
                initProgress={this.props.initProgress}
                flashProgress={this.props.flashProgress}
                onAbort={this.handleAbort}
                onClose={this.handleClose}
            />
        );
    }
}

Esp32UploadProgress.propTypes = {
    deviceId: PropTypes.string.isRequired,
    esp32Upload: PropTypes.shape({
        phase: PropTypes.string,
        text: PropTypes.string,
        abortEnabled: PropTypes.bool
    }),
    flashProgress: PropTypes.shape({
        fileIndex: PropTypes.number,
        percent: PropTypes.number
    }),
    initProgress: PropTypes.shape({
        percent: PropTypes.number
    }),
    intl: intlShape.isRequired,
    onCloseUploadProgress: PropTypes.func.isRequired,
    onResetFlashProgress: PropTypes.func.isRequired,
    onResetInitProgress: PropTypes.func.isRequired,
    onResetEsp32Upload: PropTypes.func.isRequired
};

const mapStateToProps = state => ({
    deviceId: state.scratchGui.device.deviceId,
    esp32Upload: state.scratchGui.esp32Upload,
    flashProgress: state.scratchGui.flashProgress,
    initProgress: state.scratchGui.initProgress
});

const mapDispatchToProps = dispatch => ({
    onCloseUploadProgress: () => dispatch(closeUploadProgress()),
    onResetFlashProgress: () => dispatch(resetFlashProgress()),
    onResetInitProgress: () => dispatch(resetInitProgress()),
    onResetEsp32Upload: () => dispatch(resetEsp32Upload())
});

export default compose(
    injectIntl,
    connect(
        mapStateToProps,
        mapDispatchToProps
    )
)(Esp32UploadProgress);
